/**
 * @fileoverview POST handler for the "/apps/engagement_reports/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsEngagementReportsUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostAppsEngagementReportsUpdateArchivedStateProps,
  AppsEngagementReportsUpdateArchivedStateResult,
} from "./types";

export const postAppsEngagementReportsUpdateArchivedState = reactQueryMutationAdapter(
  appsEngagementReportsUpdateArchivedStateCacheKeys,
  ({
    mark_as_archived,
    report_ids,
    undo_identifier,
  }: PostAppsEngagementReportsUpdateArchivedStateProps): Promise<AppsEngagementReportsUpdateArchivedStateResult> => {
    return fetch("/apps/engagement_reports/update_archived_state", "POST", {
      mark_as_archived,
      report_ids,
      undo_identifier,
    });
  }
);
